import { Link } from "react-router-dom";
import { COMPANY_INFO } from "../data/companyData";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#122030] text-stone-300 border-t border-stone-800">
      {/* Top accent line */}
      <div className="h-1 bg-gradient-to-r from-[#ce0611] via-red-500 to-[#99000b]"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Col 1: About / Identity */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="bg-white px-3 py-1.5 rounded-md inline-flex items-center shadow-sm">
                <img
                  src="https://assets.auxodev.dk/assets/f0baa3a2-6eb6-4b57-8f55-7b5fb1f2d6b7/tomrer-logo.png"
                  alt={COMPANY_INFO.name}
                  className="h-10 w-auto object-contain"
                  onError={(e) => {
                    e.target.src = COMPANY_INFO.logoUrl;
                  }}
                />
              </div>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed">
              Professionelt tømrerfirma, der kombinerer solidt tømrerarbejde med præcision og faglig stolthed. Vi leverer gennemtænkte løsninger til både private og erhverv.
            </p>
            <div className="pt-2 text-xs text-stone-400">
              <span className="font-semibold text-stone-300">CVR:</span> {COMPANY_INFO.cvr}
            </div>
          </div>

          {/* Col 2: Services / Ydelser */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4 border-b border-stone-700/60 pb-2">
              Vores Ydelser
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/nyt-tag-ribe"
                  className="text-stone-400 hover:text-[#ce0611] transition-colors flex items-center group"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#ce0611]/80 mr-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  Nyt tag & tagrenovering
                </Link>
              </li>
              <li>
                <Link
                  to="/nye-vinduer-og-doere-ribe"
                  className="text-stone-400 hover:text-[#ce0611] transition-colors flex items-center group"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#ce0611]/80 mr-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  Nye vinduer og døre
                </Link>
              </li>
              <li>
                <Link
                  to="/renovering-af-hus"
                  className="text-stone-400 hover:text-[#ce0611] transition-colors flex items-center group"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#ce0611]/80 mr-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  Renovering af hus
                </Link>
              </li>
              <li>
                <Link
                  to="/tilbygning-vinterhave"
                  className="text-stone-400 hover:text-[#ce0611] transition-colors flex items-center group"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#ce0611]/80 mr-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  Tilbygning & vinterhave
                </Link>
              </li>
              <li>
                <Link
                  to="/snedkerarbejde"
                  className="text-stone-400 hover:text-[#ce0611] transition-colors flex items-center group"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#ce0611]/80 mr-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  Snedkerarbejde & køkken
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Navigation links */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4 border-b border-stone-700/60 pb-2">
              Hurtige Genveje
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-stone-400 hover:text-[#ce0611] transition-colors flex items-center group">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#ce0611]/80 mr-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/vi-tilbyder" className="text-stone-400 hover:text-[#ce0611] transition-colors flex items-center group">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#ce0611]/80 mr-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  Vi tilbyder
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="text-stone-400 hover:text-[#ce0611] transition-colors flex items-center group">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#ce0611]/80 mr-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  Galleri & referencer
                </Link>
              </li>
              <li>
                <Link to="/csr" className="text-stone-400 hover:text-[#ce0611] transition-colors flex items-center group">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#ce0611]/80 mr-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  CSR & Bæredygtighed
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-stone-400 hover:text-[#ce0611] transition-colors flex items-center group">
                  <i className="fa-solid fa-chevron-right text-[10px] text-[#ce0611]/80 mr-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  Kontakt os
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact details */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4 border-b border-stone-700/60 pb-2">
              Kontakt & Lokation
            </h4>
            <div className="space-y-3 text-sm text-stone-400">
              <div className="flex items-start space-x-3">
                <i className="fa-solid fa-user text-[#ce0611] mt-1" aria-hidden="true"></i>
                <div>
                  <div className="text-white font-medium">{COMPANY_INFO.owner}</div>
                  <div className="text-xs text-stone-400">Indehaver & Tømrermester</div>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <i className="fa-solid fa-location-dot text-[#ce0611] mt-1" aria-hidden="true"></i>
                <div>
                  <a
                    href={COMPANY_INFO.mapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-[#ce0611] transition-colors block"
                  >
                    {COMPANY_INFO.address}
                    <br />
                    {COMPANY_INFO.city}
                  </a>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <i className="fa-solid fa-phone text-[#ce0611]" aria-hidden="true"></i>
                <a
                  href={`tel:${COMPANY_INFO.phoneRaw}`}
                  className="hover:text-[#ce0611] transition-colors font-medium text-stone-200 whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">{COMPANY_INFO.phone}</span>
                </a>
              </div>

              <div className="flex items-center space-x-3">
                <i className="fa-solid fa-envelope text-[#ce0611]" aria-hidden="true"></i>
                <a
                  href={`mailto:${COMPANY_INFO.email}`}
                  className="hover:text-[#ce0611] transition-colors text-stone-200 whitespace-nowrap"
                >
                  <span className="whitespace-nowrap">{COMPANY_INFO.email}</span>
                </a>
              </div>
            </div>

            <div className="pt-2">
              <Link
                to="/kontakt"
                className="inline-flex items-center text-xs font-semibold uppercase tracking-wider text-white hover:text-white py-2.5 px-5 rounded-full bg-[#ce0611] hover:bg-[#b0040e] transition-colors shadow-xs"
              >
                <span>Indhent tilbud</span>
                <i className="fa-solid fa-arrow-right ml-2 text-[10px]" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>

        {/* Areas serviced & Bottom copyright */}
        <div className="mt-12 pt-8 border-t border-stone-800/80 flex flex-col md:flex-row items-center justify-between text-xs text-stone-400 gap-4">
          <div>
            <span className="text-stone-400 font-medium">Vi dækker:</span>{" "}
            {COMPANY_INFO.areas.join(" • ")}
          </div>
          <div>
            &copy; {currentYear} {COMPANY_INFO.name}. Alle rettigheder forbeholdes.
          </div>
        </div>
      </div>
    </footer>
  );
}
